import { DOMUtils } from 'utils/dom'

export class Recaptcha {
    public static readonly scriptSource =
        'https://www.google.com/recaptcha/api.js'

    public constructor(private recaptcha: HTMLElement) {
        this.loadRecaptcha().catch((err) => console.error(err))
    }

    private async loadRecaptcha(): Promise<void> {
        await DOMUtils.ready

        if (this.recaptcha) {
            DOMUtils.loadScript(Recaptcha.scriptSource)
        }
    }
}
